import { createContext } from "react";

export interface OnlineContextData {
  isOnline: boolean;
  checkIfOnline: () => Promise<boolean>;
}

const OnlineContext = createContext<OnlineContextData>({
  isOnline: false,

  checkIfOnline: async () => Promise.resolve(false),
});

export default OnlineContext;
